// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as CustomSidebar from "../../../../pricing-dashboard/view/components/library/reuseable-components/CustomSidebar.bs.js";
import * as AllocationDashboardSidebarCmp from "./AllocationDashboardSidebarCmp.bs.js";

function AllocationDashboardSidebarContainer(Props) {
  var vehicle = Props.vehicle;
  var geo_region = Props.geo_region;
  var zones = Props.zones;
  var clusters = Props.clusters;
  var campaigns_list = Props.campaigns_list;
  var sidebar = Props.sidebar;
  var user_role = Props.user_role;
  var zone_cluster_campaigns_list = Props.zone_cluster_campaigns_list;
  var dispatch = Props.dispatch;
  var match = React.useState(function () {
        return false;
      });
  var isDirty = match[0];
  return React.createElement("div", undefined, React.createElement(CustomSidebar.make, {
                  is_open: true,
                  on_back_drop_click: (function (param) {
                      if (isDirty) {
                        if (typeof sidebar === "number" && sidebar !== 0) {
                          return Curry._1(dispatch, {
                                      TAG: /* OpenModal */10,
                                      modal: {
                                        isOpen: true,
                                        onCancel: (function (param) {
                                            return Curry._1(dispatch, /* CloseModal */3);
                                          }),
                                        onSubmit: (function (param) {
                                            Curry._1(dispatch, /* CloseModal */3);
                                            return Curry._1(dispatch, {
                                                        TAG: /* UpdateSidebarState */6,
                                                        opened_sidebar: undefined
                                                      });
                                          }),
                                        title: "Discard Changes",
                                        confirm_button_title: "Yes, Discard",
                                        cancel_button_title: "No, Cancel",
                                        modal_body: "You are about to leave this page. All the changes will be lost. Are you sure you wish to exit?"
                                      }
                                    });
                        } else {
                          return Curry._1(dispatch, {
                                      TAG: /* UpdateSidebarState */6,
                                      opened_sidebar: undefined
                                    });
                        }
                      } else {
                        return Curry._1(dispatch, {
                                    TAG: /* UpdateSidebarState */6,
                                    opened_sidebar: undefined
                                  });
                      }
                    }),
                  children: React.createElement(AllocationDashboardSidebarCmp.make, {
                        vehicle: vehicle,
                        geo_region: geo_region,
                        zones: zones,
                        clusters: clusters,
                        sidebar: sidebar,
                        campaigns_list: campaigns_list,
                        user_role: user_role,
                        zone_cluster_campaigns_list: zone_cluster_campaigns_list,
                        dispatch: dispatch,
                        setDirty: match[1]
                      })
                }));
}

var make = AllocationDashboardSidebarContainer;

export {
  make ,
  
}
/* react Not a pure module */
